<div class="row row-flex mt-1">
    <div class="col-12 align-items-center justify-content-center">
        <div class="body-card-title card-flex">
            <span #metricText class="variation-ellipsis"
                  [tooltip]="checkTextTruncation(game?.SelectedMetrics[0]?.abbrev, 'Q1')" placement="top" container="body"
                  (mouseenter)="tooltipValidation ? tooltip.show() : tooltip.hide()"
                  containerClass="cxone-game-top-team-label-tooltip"
                  triggers="manual"
                  #tooltip="bs-tooltip"
                  (mouseleave)="tooltip.hide()"
                  (wheel)="tooltip.hide()">
                {{game?.SelectedMetrics[0]?.abbrev}}
            </span>:
            <span class="body-card-title-content add-content-flex ml-1">{{getMetricValue()}}</span>
        </div>
    </div>
</div>
<cxone-game-qualifier *ngIf="game.Qualifier !== null" [game]="game" [ranking]="rankingData" [gameStatus]="gameStatus" [checkTextTruncation]="checkTextTruncation"></cxone-game-qualifier>
<div class="row mt-2">
    <div class="col-12 align-items-center justify-content-center mt-1">
        <div class="rank-icon-current padding-ranking" [ngbPopover]="popoverRankInformationCurrent" #rankingTooltip="ngbPopover" triggers="manual" (mouseenter)="rankingTooltip.open()" (mouseleave)="rankingTooltip.close()" (wheel)="rankingTooltip.close()" placement="bottom" popoverClass="cxone-game-top-team-tooltip" container="body" *ngIf="isDivisionValid">
            <span *ngIf="isRankingValid" class="rank-text-current">{{rankingData?.gameRewards?.MyRankingObj?.MyRanking}}</span>
            <span *ngIf="isRankingInvalid" class="rank-text-current">#</span>
            <svg class="icon-24 fill-valyrianSteel">
                <use href="../../../App_Themes/CXone/icons/gamification/games/rank-current.svg#rank-current"></use>
            </svg>
            <ng-template #popoverRankInformationCurrent>
                <div *ngIf="isPopoverRanking">
                    <div class="popover-rank-title">
                        {{getLocalizationString("Rank", "Rank")}} {{rankingData?.gameRewards?.MyRankingObj?.MyRanking}}
                    </div>
                    <div class="mt-1" *ngIf="game?.gameTypeName === getLocalizationString('Top_Dog', 'Top Dog')">
                        <div class="popover-rank-text">{{getCurrentValueTopDog()}}</div>
                    </div>
                    <div class="mt-1" *ngIf="game?.gameTypeName === getLocalizationString('Top_Team', 'Top Team')">
                        <div class="popover-rank-text">{{getParentGroup()}} - {{getMetricValue()}}</div>
                    </div>
                    <div class="mt-2">
                        <span class="mr-2">
                            <svg class="icon-16 fill-valyrianSteel">
                                <use href="../../../App_Themes/CXone/icons/gamification/games/coin-reward.svg#coin-reward"></use>
                            </svg>
                        </span>
                        <span class="popover-rank-text mr-3" *ngIf="isCoinsAmountValid">{{rankingData?.gameRewards?.MyRankingObj?.CoinsAmount}}</span>
                        <span class="popover-rank-text mr-3" *ngIf="isCoinsAmountInvalid">--</span>
                        <span class="mr-2">
                            <svg class="icon-16 fill-valyrianSteel">
                                <use href="../../../App_Themes/CXone/icons/gamification/games/badge-reward.svg#badge-reward"></use>
                            </svg>
                        </span>
                        <div *ngIf="isBadgesValid" class="d-inline">
                            <img src="../Admin/ImageResizer.aspx?imgid={{rankingData?.gameRewards?.MyRankingObj?.Badges[0].ImageID}}&w=24&h=24" class="img-fluid" />
                        </div>
                        <div *ngIf="isBadgesInvalid" class="d-inline">
                            --
                        </div>
                    </div>
                </div>
                <div *ngIf="isPopoverNoRank">
                    <div class="popover-rank-title">
                        {{getLocalizationString("No_Rank", "No Rank")}}
                    </div>
                    <div class="mt-2">
                        <span class="mr-2">
                            <svg class="icon-16 fill-valyrianSteel">
                                <use href="../../../App_Themes/CXone/icons/gamification/games/coin-reward.svg#coin-reward"></use>
                            </svg>
                        </span>
                        <span class="popover-rank-text mr-3">--</span>
                        <span class="mr-2">
                            <svg class="icon-16 fill-valyrianSteel">
                                <use href="../../../App_Themes/CXone/icons/gamification/games/badge-reward.svg#badge-reward"></use>
                            </svg>
                        </span>
                        <span class="popover-rank-text">--</span>
                    </div>
                </div>
            </ng-template>
        </div>
        <div class="rank-division padding-ranking" *ngIf="isDivisionValid"></div>
        <div class="rank-icon padding-ranking" *ngFor="let reward of game.TopDogRewards; index as i" #p="ngbPopover" [ngbPopover]="popoverRankInformation" triggers="manual" placement="bottom" (mouseover)="openPopover(p)" (mouseleave)="leavePopover(p)" (wheel)="p.close()" popoverClass="cxone-game-top-team-tooltip" container="body">
            <span class="rank-text" *ngIf="isPlaceValid(i)">{{i+1}}</span>
            <span class="rank-text-current" *ngIf="isPlaceCurrentValid(i)">{{i+1}}</span>
            <svg class="icon-24 fill-valyrianSteel" *ngIf="isPlaceValid(i)">
                <use href="../../../App_Themes/CXone/icons/gamification/games/rank.svg#rank"></use>
            </svg>
            <svg class="icon-24 fill-valyrianSteel" *ngIf="isPlaceCurrentValid(i)">
                <use href="../../../App_Themes/CXone/icons/gamification/games/rank-current.svg#rank-current"></use>
            </svg>
            <ng-template #popoverRankInformation >
                <div (click)="$event.stopPropagation()" (mouseleave)="leavePopover(p)" (mouseenter)="changeInsidePopoverFlag()">
                    <div class="popover-rank-title">
                        {{getLocalizationString("Rank", "Rank")}} {{i+1}}
                    </div>
                    <div class="mt-1 popover-agents" *ngIf="gameStatus !== 'Upcoming' && game?.gameTypeName === getLocalizationString('Top_Team', 'Top Team')">
                        <div *ngFor="let users of rankingData?.gameRewards?.Rankings; let j = index">
                            <div class="popover-rank-text" *ngIf="j === 0 && rankingData?.gameRewards?.MyRankingObj?.MyRanking === (i+1) && validateCurrentQualifier()">{{getCurrentValueTopTeam()}}</div>
                            <div class="popover-rank-text" *ngIf="users.Place === (i+1) && users.GroupID !== rankingData?.gameRewards?.MyRankingObj?.MatchingRankLevelID">
                                {{users.GroupName}} - {{getFormattedData(users.FirstMetricActualScore, game?.SelectedMetrics[0].conversionType)}}
                            </div>
                        </div>
                    </div>
                    <div class="mt-1 popover-agents" *ngIf="gameStatus !== 'Upcoming' && game?.gameTypeName === getLocalizationString('Top_Dog', 'Top Dog')">
                        <div *ngFor="let users of rankingData?.gameRewards?.Rankings; let j = index">
                            <div class="popover-rank-text" *ngIf="j === 0 && rankingData?.gameRewards?.MyRankingObj?.MyRanking === (i+1) && validateCurrentQualifier()">{{getCurrentValueTopDog()}}</div>
                            <div class="popover-rank-text" *ngIf="users.Place === (i+1) && users.LoginID !== navigationService.loggedInID">
                                {{users.GroupName}} - {{getFormattedData(users.FirstMetricActualScore, game?.SelectedMetrics[0].conversionType)}}
                            </div>
                        </div>
                    </div>
                    <div class="mt-2">
                        <span class="mr-2">
                            <svg class="icon-16 fill-valyrianSteel">
                                <use href="../../../App_Themes/CXone/icons/gamification/games/coin-reward.svg#coin-reward"></use>
                            </svg>
                        </span>
                        <span class="popover-rank-text mr-3">{{(reward.Coins !== null) ? reward.Coins.rewardValue : "--"}}</span>
                        <span class="mr-2">
                            <svg class="icon-16 fill-valyrianSteel">
                                <use href="../../../App_Themes/CXone/icons/gamification/games/badge-reward.svg#badge-reward"></use>
                            </svg>
                        </span>
                        <div *ngIf="getBadgeUsingIndex(game, i) !== null" class="d-inline">
                            <img src="{{getBadgeUsingIndex(game, i)}}" class="img-fluid" />
                        </div>
                        <div *ngIf="getBadgeUsingIndex(game, i) === null" class="d-inline">
                            --
                        </div>
                    </div>
                </div>
            </ng-template>
        </div>
    </div>
</div>
